import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const HIGHLIGHTED_PLUGIN_ID = 'highlighted' as const;
export type HighlightedPluginId = typeof HIGHLIGHTED_PLUGIN_ID;

export type HighlightedPluginElement = EditorElement;

export type HighlightedPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
    words: Array<string | RegExp>;
  }
>;

export type HighlightedPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    HighlightedPluginOptions & {
      pluginID: HighlightedPluginId;
      pluginName: string;

      component: ComponentType<any>;
      words: Array<string | RegExp>;
    }
>;
